import { TextArea } from 'framework/form';
import { NON_STRICT_RULES } from './employeeContractsService';
import { NonStrictRulesHandler } from 'domain/people/shared/formRules';
import { Typography } from '@mui/material';

const ContractNotStrictRulesHandler = ({ errorMap }: { errorMap: Dictionary<any> }) => {
  return (
    <NonStrictRulesHandler
      title="Contract violates the following rules:"
      nonStrictRules={NON_STRICT_RULES}
      errorMap={errorMap}
    >
      <Typography variant="body1" pt={2}>
        Please return to contract creation form and change the contract details so that it does not violate the rules or
        create contract with rules violated.
      </Typography>
      <Typography variant="body1" pt={2}>
        If you need to create the contract without changes in its details, please specify a reason for the rules
        violation.
      </Typography>

      <TextArea source="comment" label="" />
    </NonStrictRulesHandler>
  );
};

export default ContractNotStrictRulesHandler;
